import { render, staticRenderFns } from "./AsuPolicy.vue?vue&type=template&id=7817cd66"
import script from "./AsuPolicy.vue?vue&type=script&lang=js"
export * from "./AsuPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports